export default __webpack_public_path__ + "images/9030454fa3d271b0c268ce02d952f7f6-celebrate-progress.svg";